import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../utils/api';

const initialState = {
    data: null,
    isLoading: true,
    error: null
};

export const fetchProductData = createAsyncThunk('data/fetchProductData', async () => {
    try {
        const response = await apiRequest('get', 'products');

        let finalData = response?.data;
        // const sortedKK = response?.data?.filter((p) => p.category === 'KK').sort((a, b) => a.name.localeCompare(b.name));
        // const sortedTITO = response?.data?.filter((p) => p.category === 'TITO').sort((a, b) => a.name.localeCompare(b.name));
        // const sortedLOOSE = response?.data?.filter((p) => p.category === 'LOOSE').sort((a, b) => a.name.localeCompare(b.name));

        // // Concatenate and debug output
        // const sortedProducts = [...sortedKK, ...sortedTITO, ...sortedLOOSE];

        finalData.sort((a, b) => {
            // First, ensure "KK" category comes before others, then "Tito", then others alphabetically
            // const priority = {
            //     KK: 1,
            //     'KK Ctn': 2,
            //     'KK Loose': 3,
            //     'KK POPS': 4,
            //     'KK POPS Bora': 5,
            //     'TITO': 6,
            //     'TITO COTTON': 7,
            //     'TITO Bundle': 8,
            //     'Tito Snacks': 9,
            //     'TITO Bora': 10,
            //     'LOOSE': 11,
            //     'Legacy Foods': 12,
            //     'Malai Boti': 13
            // };
            const priority = {
                KK: 1,
                TITO: 2,
                LOOSE: 3,
                'Legacy Foods': 4,
                'Malai Boti': 5,
                'General Catageory': 6
            };
            const aPriority = priority[a.category] || 12; // Default to 3 for other categories
            const bPriority = priority[b.category] || 12;

            if (aPriority < bPriority) return -1;
            if (aPriority > bPriority) return 1;

            // If categories are equal, sort by name (A-Z)
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;

            return 0;
        });

        return finalData;
    } catch (error) {
        throw error?.response?.data?.message || error?.response?.data || error?.message;
    }
});

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProductData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload;
            })
            .addCase(fetchProductData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error;
            });
    }
});

export default productSlice.reducer;
